import styled from 'styled-components'  
import { PrimaryColor } from 'ui/styled';
 
export const DashboardHeaderContainer = styled.div.attrs({ 
})`           
    height: 105px;
    width: 100%;

    background: linear-gradient(45deg, rgba(${PrimaryColor}, .45) 0%, rgba(${PrimaryColor}, .6) 25%, rgba(${PrimaryColor}, .75) 50%, rgba(${PrimaryColor}, .9) 75%, rgba(${PrimaryColor}, 1) 100%);
    background: var(--primary-color);
    padding: 0 25px;

    display: flex;
    justify-content: space-between;
    align-items: center;

    /* No celular o menu de cima some — a navegação passa a ser a barra fixa de baixo
       (componente BottomNav), como nos apps. */
    @media(max-width: 767px){
        display: none;
    }
`;

export const DashboardHeaderSide = styled.div.attrs({
})`
    display: flex;
    justify-content: flex-start;
    align-items: center;

    position: relative;

    /* No celular, os itens do menu podem quebrar como blocos inteiros e ficam
       centralizados — evita "Meus / favoritos" quebrando no meio da palavra. */
    @media(max-width: 767px){
        flex-wrap: wrap;
        justify-content: center;
    }
`;
 
export const DashboardHeaderSideMobile = styled.div.attrs({ 
})`            
    display: flex;
    justify-content: flex-start;
    align-items: center; 

    @media(max-width: 399px){
        flex-direction: column; 
    }
`;

export const DashboardHeaderAction = styled.div.attrs({ 
})`           
    color: var(--white-color);
    font-size: 16px;
    white-space: nowrap;
    cursor: pointer;

    ${
        props => props.active ? `
            font-weight: bold;
        ` : ``
    }

    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 20px;

    cursor: pointer;
    &:hover{
        text-decoration: underline;
    }


    @media(max-width: 767px){
        padding: 0 10px;
    }

    @media(max-width: 399px){
        padding: 10px;
    }
`; 

export const DashboardHeaderActionIcon = styled.img.attrs({ 
})`            
    margin-bottom: -8px;

    /* Logo menor e centralizada no celular, ocupando menos altura no topo. */
    @media(max-width: 767px){
        width: 64px;
        height: auto;
        margin: 4px 0 6px 0;
    }
`;